import { AdditionalUserSettings, IFieldDisplayValidator, User } from "@samc/auth-authorization";

export class TraderDisplayValidator implements IFieldDisplayValidator<User> {
  fieldName: string;
  constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  public isVisible(value: User, userDataFields: AdditionalUserSettings): boolean {
    return value.roles.filter(r => r.name == 'Trader').length > 0;
  }
}